import React, { useState, useEffect } from 'react';
import './Admin.css';

const AboutManager = () => {
    const [content, setContent] = useState({
        name: 'Татьяна',
        experience: '10+ лет',
        specialization: 'Свадебный стилист, визажист, мастер причесок',
        description: '',
        imageUrl: null,
        showImage: true
    });
    const [settings, setSettings] = useState({
        title: 'Обо мне',
        showTitle: true,
        layout: 'text-left'
    });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            const [contentRes, settingsRes] = await Promise.all([
                fetch('/api/content/about?field=content'),
                fetch('/api/content/about?field=settings')
            ]);

            const contentData = await contentRes.json();
            const settingsData = await settingsRes.json();

            if (contentData.data) {
                setContent(contentData.data);
            }
            if (settingsData.data) {
                setSettings(settingsData.data);
            }
        } catch (error) {
            console.error('Ошибка загрузки:', error);
        } finally {
            setLoading(false);
        }
    };

    const saveContent = async () => {
        try {
            await fetch('/api/content/about', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'content', data: content })
            });
            setMessage('✅ Контент сохранен');
            setTimeout(() => setMessage(''), 2000);
        } catch (error) {
            setMessage('❌ Ошибка сохранения');
        }
    };

    const saveSettings = async () => {
        try {
            await fetch('/api/content/about', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'settings', data: settings })
            });
            setMessage('✅ Настройки сохранены');
            setTimeout(() => setMessage(''), 2000);
        } catch (error) {
            setMessage('❌ Ошибка сохранения');
        }
    };

    const handleImageUpload = async (file) => {
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append('aboutImage', file);

        try {
            const response = await fetch('/api/upload/about-image', {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setContent({ ...content, imageUrl: data.url });
                setMessage('✅ Фото загружено');
                setTimeout(() => setMessage(''), 2000);
            }
        } catch (error) {
            setMessage('❌ Ошибка загрузки');
        } finally {
            setUploading(false);
        }
    };

    if (loading) return <div className="loading-spinner">Загрузка...</div>;

    return (
        <div className="about-manager">
            <h2>👤 Обо мне</h2>

            {message && <div className="message success">{message}</div>}

            <div className="settings-section">
                <h3>Настройки</h3>
                <div className="settings-grid">
                    <div className="setting-item">
                        <label>Заголовок</label>
                        <input
                            type="text"
                            value={settings.title}
                            onChange={(e) => setSettings({...settings, title: e.target.value})}
                        />
                    </div>
                    <div className="setting-item checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={settings.showTitle}
                                onChange={(e) => setSettings({...settings, showTitle: e.target.checked})}
                            />
                            Показывать заголовок
                        </label>
                    </div>
                    <div className="setting-item">
                        <label>Расположение текста</label>
                        <select
                            value={settings.layout}
                            onChange={(e) => setSettings({...settings, layout: e.target.value})}
                        >
                            <option value="text-left">Текст слева, фото справа</option>
                            <option value="text-right">Текст справа, фото слева</option>
                        </select>
                    </div>
                </div>
                <button onClick={saveSettings} className="save-settings-btn">Сохранить настройки</button>
            </div>

            <div className="content-section">
                <h3>Контент</h3>

                <div className="field-group">
                    <label>Имя</label>
                    <input
                        type="text"
                        value={content.name || ''}
                        onChange={(e) => setContent({...content, name: e.target.value})}
                    />
                </div>

                <div className="field-group">
                    <label>Опыт</label>
                    <input
                        type="text"
                        value={content.experience || ''}
                        onChange={(e) => setContent({...content, experience: e.target.value})}
                    />
                </div>

                <div className="field-group">
                    <label>Фото мастера</label>
                    <div className="image-upload-area">
                        {content.imageUrl ? (
                            <div className="image-preview">
                                <img src={`${content.imageUrl}`} alt="preview" />
                                <button onClick={() => setContent({...content, imageUrl: null})} className="remove-image-btn">
                                    ✕ Удалить
                                </button>
                            </div>
                        ) : (
                            <label className="upload-image-label">
                                {uploading ? '⏳ Загрузка...' : '📸 Загрузить фото'}
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleImageUpload(e.target.files[0])}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        )}
                    </div>
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={content.showImage !== false}
                            onChange={(e) => setContent({...content, showImage: e.target.checked})}
                        />
                        Показывать фото на сайте
                    </label>
                </div>

                <div className="field-group">
                    <label>Текст истории</label>
                    <textarea
                        value={content.description || ''}
                        onChange={(e) => setContent({...content, description: e.target.value})}
                        rows="20"
                        placeholder="Введите текст..."
                    />
                </div>

                <button onClick={saveContent} className="save-btn">💾 Сохранить контент</button>
            </div>
        </div>
    );
};

export default AboutManager;